import { type FunctionComponent, type ReactNode, type FormEvent } from 'react';
import LoginWell from './LoginWell.tsx';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

type Props = {
    children: ReactNode;
    heading: ReactNode;
    subtitle?: ReactNode;
    handleSubmit: (e: FormEvent<HTMLFormElement>) => void;
    socialLoginButtons?: ReactNode;
    hasMessage?: boolean;
};

const LoginFormWrapper: FunctionComponent<Props> = ({
    children,
    heading,
    subtitle,
    handleSubmit,
    socialLoginButtons,
    hasMessage,
}) => {
    return (
        <LoginWell
            showCookieDisclaimer
            heading={heading}
            subtitle={subtitle}
            hasMessage={hasMessage}
        >
            {socialLoginButtons}
            <form className={classnames(dibsCss.pxSmall, dibsCss.pbSmall)} onSubmit={handleSubmit}>
                {children}
            </form>
        </LoginWell>
    );
};

export default LoginFormWrapper;
